<div class="autocomplete" [class.autocomplete--disabled]="disabled" [class.autocomplete--multi]="multiSelect">
  <div class="autocomplete__input-wrapper">
    <input
      type="text"
      class="autocomplete__input"
      [placeholder]="placeholder"
      [attr.autocomplete]="inputAutocomplete"
      [attr.name]="inputName || defaultInputName"
      autocapitalize="off"
      autocorrect="off"
      spellcheck="false"
      [readOnly]="isInputReadonly"
      [disabled]="disabled"
      [ngModel]="searchTerm"
      (ngModelChange)="updateSearchTerm($event)"
      (focus)="handleFocus()"
      (blur)="onBlur()"
      (keydown)="onKeydown($event)"
      [attr.aria-expanded]="isOpen"
      [attr.aria-activedescendant]="isOpen ? getHighlightedId(highlightedIndex) : null"
      [attr.aria-controls]="isOpen ? 'autocomplete-dropdown' : null"
      role="combobox"
      aria-autocomplete="list" />

    @if (searchTerm && (!multiSelect || selectedValues.length === 0)) {
    <button
      type="button"
      class="autocomplete__clear"
      (click)="clearSelection()"
      (keydown.enter)="clearSelection()"
      (keydown.space)="clearSelection()"
      tabindex="0"
      aria-label="Clear selection">
      <ng-glyph name="close" size="16px"></ng-glyph>
    </button>
    }

    <ng-glyph class="autocomplete__icon" name="search" size="18px"></ng-glyph>
  </div>

  @if (multiSelect && selectedValues.length > 0) {
  <div class="autocomplete__selected-values">
    @for (option of getSelectedOptions(); track option.value) {
    <div class="autocomplete__chip">
      <span>{{ option.label }}</span>
      <button
        type="button"
        class="autocomplete__chip-remove"
        (click)="removeSelectedValue(option.value)"
        (keydown.enter)="removeSelectedValue(option.value)"
        (keydown.space)="removeSelectedValue(option.value)"
        tabindex="0"
        aria-label="Remove {{ option.label }}">
        <ng-glyph name="close" size="14px"></ng-glyph>
      </button>
    </div>
    }
  </div>
  } @if (isOpen && isLoading) {
  <div class="autocomplete__dropdown">
    <div class="autocomplete__loading">Loading options...</div>
  </div>
  } @if (isOpen && !isLoading && filteredOptions.length > 0) {
  <div class="autocomplete__dropdown" role="listbox" id="autocomplete-dropdown" (mousedown)="$event.preventDefault()">
    @for (option of filteredOptions; track option.value; let i = $index) {
    <div
      class="autocomplete__option"
      [class.autocomplete__option--highlighted]="i === highlightedIndex"
      [class.autocomplete__option--selected]="isSelected(option.value)"
      (click)="selectOption(option)"
      (keydown.enter)="selectOption(option)"
      (mouseenter)="highlightOption(i)"
      [id]="getHighlightedId(i)"
      role="option"
      [attr.aria-selected]="i === highlightedIndex"
      tabindex="0">
      @if (multiSelect) {
      <ng-glyph
        [name]="isSelected(option.value) ? 'check_box' : 'check_box_outline_blank'"
        size="18px"
        class="autocomplete__option-checkbox"></ng-glyph>
      } {{ option.label }}
    </div>
    }
  </div>
  } @if (isOpen && !isLoading && filteredOptions.length === 0 && (searchTerm.length >= minLength || prefetchOnInit)) {
  <div class="autocomplete__dropdown">
    <div class="autocomplete__no-results">
      {{ searchTerm.length > 0 ? 'No results found for "' + searchTerm + '"' : "No options available." }}
    </div>
  </div>
  }
</div>
